import { fetchWrapper } from '../helpers';

export const portfolioService = {
  getById,
  create,
  getCatalogForm
};

const baseUrl = `${process.env.BASE_URL}/api/vendor/portfolio`;
const baseUrlAPI = `${process.env.API_BASE_URL}/form/portfolio`;

function getById(id) {
  return fetchWrapper.get(`${baseUrl}?id=${id}`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

// API
function getCatalogForm() {
	return fetchWrapper.get(baseUrlAPI);
}